export default "__VITE_ASSET__C_ru4V5z__"